import React, { useEffect, useMemo, useState } from 'react';
import { ViewStyle } from 'react-native';
import { AppTextView } from '@/components/base/app.text.view';
import { smartDate } from '@matap/shared';
import { getCurrentTime } from '../../utils';

function BaseTimerView({ createdAt, style }: { createdAt: string; style?: ViewStyle }) {
  const start = useMemo(() => smartDate(createdAt), [createdAt]);
  const [duration, setDuration] = useState('');
  useEffect(() => {
    const tid = setInterval(() => {
      const diff = start.duration(getCurrentTime());
      const hours = Math.floor(diff.asHours());
      const minutes = String(diff.minutes()).padStart(2, '0');
      const seconds = String(diff.seconds()).padStart(2, '0');
      setDuration(hours > 0 ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`);
    }, 100);

    return () => {
      clearInterval(tid);
    };
  }, [createdAt, start]);

  return <AppTextView bold text={duration} variant={'medium'} textColor={'jade'} style={style as any} />;
}

export const QueueWaitingTimer = React.memo(BaseTimerView);
